import React from "react";
import { Link } from "react-router-dom";

const WhyChooseUs = () => {
  return (
    <section
      id="why-choose-us"
      className="py-5"
      style={{ padding: "60px 0", background: "#ffffff" }}
    >
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-8">
            <span className="hero-badge bg-gold bg-opacity-10">
              <i className="fas fa-star me-2"></i> Why Choose Us
            </span>
            <h2 className="display-5 fw-bold mt-3">Why FORMAX MONEY?</h2>
            <p className="lead text-muted">
              Partner with India's fastest-growing Corporate Business
              Correspondent network and unlock unparalleled benefits for your
              business.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {/* Bank Licensed & Trusted */}
          <div className="col-md-6 col-lg-4">
            <div className="why-card text-center p-4 rounded-4 h-100">
              <div className="why-icon mx-auto mb-3">
                <i className="fas fa-bank fa-2x"></i>
              </div>
              <h5 className="fw-bold mb-2">Bank Licensed & Regulated</h5>
              <p className="text-muted small mb-0">
                Authorized by leading banks as a Corporate Business
                Correspondent. Fully compliant with RBI guidelines for BC
                operations.
              </p>
            </div>
          </div>

          {/* Highest Commissions */}
          <div className="col-md-6 col-lg-4">
            <div className="why-card text-center p-4 rounded-4 h-100">
              <div className="why-icon mx-auto mb-3">
                <i className="fas fa-rupee-sign fa-2x"></i>
              </div>
              <h5 className="fw-bold mb-2">Highest Commissions</h5>
              <p className="text-muted small mb-0">
                Industry-best payout structure on AEPS, DMT, CMS, and UPI Cash
                Point. Earn more with every transaction.
              </p>
            </div>
          </div>

          {/* Real-time Settlements */}
          <div className="col-md-6 col-lg-4">
            <div className="why-card text-center p-4 rounded-4 h-100">
              <div className="why-icon mx-auto mb-3">
                <i className="fas fa-clock fa-2x"></i>
              </div>
              <h5 className="fw-bold mb-2">Real-time Settlements</h5>
              <p className="text-muted small mb-0">
                Instant commission settlements directly to your bank account. No
                waiting periods, no delays.
              </p>
            </div>
          </div>

          {/* PAN India Presence */}
          <div className="col-md-6 col-lg-4">
            <div className="why-card text-center p-4 rounded-4 h-100">
              <div className="why-icon mx-auto mb-3">
                <i className="fas fa-map-marker-alt fa-2x"></i>
              </div>
              <h5 className="fw-bold mb-2">PAN India Operations</h5>
              <p className="text-muted small mb-0">
                Serve customers across all states with our nationwide BC Agent
                network and multi-language support.
              </p>
            </div>
          </div>

          {/* 24/7 Dedicated Support */}
          <div className="col-md-6 col-lg-4">
            <div className="why-card text-center p-4 rounded-4 h-100">
              <div className="why-icon mx-auto mb-3">
                <i className="fas fa-headset fa-2x"></i>
              </div>
              <h5 className="fw-bold mb-2">24/7 Dedicated Support</h5>
              <p className="text-muted small mb-0">
                Technical assistance and operational support available round the
                clock. We're always here to help.
              </p>
            </div>
          </div>

          {/* Zero Hidden Charges */}
          <div className="col-md-6 col-lg-4">
            <div className="why-card text-center p-4 rounded-4 h-100">
              <div className="why-icon mx-auto mb-3">
                <i className="fas fa-shield-alt fa-2x"></i>
              </div>
              <h5 className="fw-bold mb-2">Zero Hidden Charges</h5>
              <p className="text-muted small mb-0">
                Complete transparency in pricing and commissions. No surprise
                fees or hidden deductions.
              </p>
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        {/* <div className="row mt-5 pt-3 justify-content-center">
          <div className="col-md-10">
            <div className="trust-bar d-flex flex-wrap justify-content-center gap-4 p-4 rounded-4">
              <div className="text-center">
                <div className="trust-number">500+</div>
                <div className="trust-label">Active BC Agents</div>
              </div>
              <div className="trust-divider"></div>
              <div className="text-center">
                <div className="trust-number">15+</div>
                <div className="trust-label">Partner Banks</div>
              </div>
              <div className="trust-divider"></div>
              <div className="text-center">
                <div className="trust-number">10L+</div>
                <div className="trust-label">Monthly Transactions</div>
              </div>
              <div className="trust-divider"></div>
              <div className="text-center">
                <div className="trust-number">98%</div>
                <div className="trust-label">Customer Satisfaction</div>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      <style>{`
    .why-card {
      background: white;
      border: 1px solid rgba(0,0,0,0.05);
      transition: all 0.3s ease;
      box-shadow: 0 5px 15px rgba(0,0,0,0.02);
    }
    .why-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 35px -12px rgba(0,0,0,0.1);
      border-color: rgba(212, 175, 55, 0.3);
    }
    .why-icon {
      width: 70px;
      height: 70px;
      background: linear-gradient(135deg, rgba(212, 175, 55, 0.12) 0%, rgba(212, 175, 55, 0.05) 100%);
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .why-icon i {
      color: #D4AF37;
    }
    .trust-bar {
      background: linear-gradient(135deg, #0A2540, #1A3A5F);
      border-radius: 60px;
    }
    .trust-number {
      font-size: 1.8rem;
      font-weight: 800;
      font-family: 'Space Grotesk', monospace;
      color: #D4AF37;
    }
    .trust-label {
      font-size: 0.85rem;
      color: rgba(255,255,255,0.7);
    }
    .trust-divider {
      width: 1px;
      height: 40px;
      background: rgba(255,255,255,0.2);
    }
    @media (max-width: 768px) {
      .trust-bar {
        border-radius: 30px;
        padding: 1.5rem !important;
      }
      .trust-number {
        font-size: 1.3rem;
      }
      .trust-divider {
        display: none;
      }
      .why-icon {
        width: 55px;
        height: 55px;
      }
      .why-icon i {
        font-size: 1.5rem;
      }
    }
  `}</style>
    </section>
  );
};

export default WhyChooseUs;
